<template>
  <div class="row h-100 no-gutters">
    <div class="auth-form mx-auto my-auto col-md-5 col-lg-3">
      <div class="card">
        <div class="card-body">
          <h1 style="text-align: center">
            <img
              id="main-logo"
              class="d-inline-block align-top mr-1"
              style="max-width: 100px;"
              src="@/assets/images/logo.jpg"
              alt="" />
          </h1>
          <d-alert
            v-if="error"
            theme="danger"
            show>
            Błąd podczas zmiany hasła. Spróbuj ponownie.
          </d-alert>
          <d-alert
            v-if="success"
            theme="success"
            show>
            Hasło zostało zmienione - możesz się zalogować
          </d-alert>

          <h4 class="text-center mt-4 mb-4">
            Zmiana hasła
          </h4>

          <validation-observer ref="password-change-form" tag="form">
            <div class="form-group">
              <label for="email">
                Hasło:
              </label>

              <validation-provider
                rules="required|min:8"
                name="password"
                v-slot="{ errors }">
                <d-input
                  type="password"
                  :state="errors.length ? 'invalid' : null"
                  v-model="password" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>

            <div class="form-group">
              <label for="email">
                Powtórz hasło:
              </label>

              <validation-provider
                rules="required|min:8|password:password"
                name="password-confirmation"
                v-slot="{ errors }">
                <d-input
                  type="password"
                  :state="errors.length ? 'invalid' : null"
                  v-model="password_confirmation" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>

            <d-button
              pill
              class="ml-auto mr-auto mt-4 d-table"
              @click.prevent="validateForm"
              :disabled="submitting">
              <template v-if="!submitting">Zmień hasło</template>
              <template v-else>Zmiana hasła&hellip;</template>
            </d-button>
          </validation-observer>

          <div class="pt-3 text-center">
            <small>
              <router-link to="/login">
                Zaloguj się
              </router-link>
            </small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormUtils from './../utils/FormUtils.js';

export default {
  name: 'PasswordChange',
  data () {
    return {
      error: false,
      submitting: false,
      success: false,
      password: '',
      password_confirmation: ''
    }
  },
  methods: {
    validateForm () {
      FormUtils.validate(this.$refs['password-change-form'], this.reset);
    },
    reset () {
      this.error = false;
      this.submitting = true;
      this.success = false;

      this.$http.post('/password/reset', {
        email: this.$route.params.email,
        token: this.$route.params.token,
        password: this.password,
        password_confirmation: this.password_confirmation
      }).then((response) => {
        this.submitting = false;

        if (response.data.success) {
          this.success = true;
        } else {
          this.error = true;
        }
      }).catch(() => {
        this.submitting = false;
        this.error = true;
      });
    }
  }
}
</script>
